import { render, staticRenderFns } from "./SysDialog.vue?vue&type=template&id=a3890a92&scoped=true"
import script from "./SysDialog.vue?vue&type=script&lang=js"
export * from "./SysDialog.vue?vue&type=script&lang=js"
import style0 from "./SysDialog.vue?vue&type=style&index=0&id=a3890a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3890a92",
  null
  
)

export default component.exports